<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />

        <bay-window />
    </div>
</template>
<script>

import bayWindow from '@/components/bayWindow.vue'
export default {
	components: { bayWindow }
}
</script>